import { render, staticRenderFns } from "./ActivityBook.vue?vue&type=template&id=6854ca00&"
import script from "./ActivityBook.vue?vue&type=script&lang=js&"
export * from "./ActivityBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports